<template>
  <v-menu
    v-model="menu"
    menu-props="offsetY"
    :nudge-bottom="45"
    max-width="600"
    min-width="600"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on: menu }">
      <ToolbarIconButton
        :tooltip="'Настройка'"
        :icon="'build'"
        :is-flat="flatSettingsButton"
        :btn-color="colorSettingsButton"
        :icon-color="iconColorSettingsButton"
        :is-top-position="isTopPositionSettingsButton"
        data-test="settingsButton"
        v-on="{ ...menu }"
      />
    </template>
    <v-card>
      <v-card-title class="py-0">
        <v-layout column>
          <h2 class="title mt-3">
            Настройка колонок
          </h2>
          <v-flex>
            <v-layout row>
              <v-select
                v-model="selected"
                :items="savedSettings"
                label="Сохранённые настройки"
                hide-details
                item-text="title"
                item-value="id"
                return-object
                menu-props="offsetY"
                outline
                clearable
                no-data-text="Нет данных"
                @click:clear="clearSelected"
                @input="processSetting"
              >
                <template v-slot:selection="data">
                  <span :selected="data.selected">
                    {{ data.item.title }}
                  </span>
                </template>
                <template v-slot:item="data">
                  <template>
                    <v-list-tile-content v-text="data.item.title" />
                  </template>
                </template>
              </v-select>
              <v-menu
                v-model="menuSave"
                :close-on-content-click="false"
                :nudge-width="200"
                menu-props="offsetY"
              >
                <v-btn
                  slot="activator"
                  icon
                  small
                  class="mb-0 mt-3"
                >
                  <v-icon color="grey darken-1">
                    save
                  </v-icon>
                </v-btn>
                <v-card>
                  <v-card-text>
                    <v-text-field
                      v-model="settingTitle"
                      :required="true"
                      :rules="[
                        v => !!v || 'Наименование обязательно к заполнению'
                      ]"
                      label="Наименование настройки"
                    />
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn
                      small
                      flat
                      color="primary"
                      @click="saveSetting"
                    >
                      Сохранить
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
              <v-btn
                v-if="selected"
                icon
                small
                class="mb-0 mt-3 ml-0"
                @click="deleteSetting(selected)"
              >
                <v-icon color="grey darken-1">
                  delete
                </v-icon>
              </v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <v-layout>
          <v-flex xs6>
            <h3 class="subheading grey--text text--darken-1">
              Отображаемые
            </h3>
            <div class="list">
              <v-list
                v-for="(item, index) in selectedColumns"
                :key="index"
                class="py-0"
              >
                <v-list-tile
                  class="list-title"
                  :style="{
                    cursor: item.type === 'group' ? 'default' : 'pointer'
                  }"
                >
                  <v-list-tile-content>
                    <v-list-tile-title
                      @click="moveColumn(item)"
                      v-text="item.title"
                    />
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-layout>
                      <v-btn
                        flat
                        small
                        icon
                        class="mx-1"
                        :disabled="index === 0 || item.type === 'group'"
                        @click="moveColumnUp(item)"
                      >
                        <v-icon small>
                          keyboard_arrow_up
                        </v-icon>
                      </v-btn>
                      <v-btn
                        flat
                        small
                        icon
                        class="mx-1"
                        :disabled="
                          index === selectedColumns.length - 1 ||
                            item.type === 'group'
                        "
                        @click="moveColumnDown(item)"
                      >
                        <v-icon small>
                          keyboard_arrow_down
                        </v-icon>
                      </v-btn>
                    </v-layout>
                  </v-list-tile-action>
                </v-list-tile>

                <v-list-tile
                  v-for="subItem in item.children"
                  :key="subItem.title"
                  class="list-title"
                  color="grey darken-2"
                >
                  <v-list-tile-content>
                    <v-list-tile-title
                      class="pl-3"
                      @click="moveColumn(item, subItem)"
                      v-text="subItem.title"
                    />
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-layout>
                      <v-btn
                        flat
                        small
                        icon
                        class="mx-1"
                        :disabled="index === 0"
                        @click="moveColumnUp(item, subItem)"
                      >
                        <v-icon
                          small
                          color="grey darken-2"
                        >
                          keyboard_arrow_up
                        </v-icon>
                      </v-btn>
                      <v-btn
                        flat
                        small
                        icon
                        class="mx-1"
                        :disabled="index === item.children.length - 1"
                        @click="moveColumnDown(item, subItem)"
                      >
                        <v-icon
                          small
                          color="grey darken-2"
                        >
                          keyboard_arrow_down
                        </v-icon>
                      </v-btn>
                    </v-layout>
                  </v-list-tile-action>
                </v-list-tile>
              </v-list>
            </div>
          </v-flex>
          <v-divider
            vertical
            class="mx-1"
          />
          <v-flex xs6>
            <h3 class="subheading grey--text text--darken-1">
              Скрытые
            </h3>
            <div class="list">
              <v-list
                v-for="(item, index) in availableColumns"
                :key="index"
                class="py-0"
              >
                <v-list-tile @click="moveColumn(item)">
                  <v-list-tile-content>
                    <v-list-tile-title v-text="item.title" />
                  </v-list-tile-content>
                </v-list-tile>

                <v-list-tile
                  v-for="subItem in item.children"
                  :key="subItem.title"
                  color="grey darken-2"
                  @click="moveColumn(item, subItem)"
                >
                  <v-list-tile-content>
                    <v-list-tile-title
                      class="pl-3"
                      v-text="subItem.title"
                    />
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <SaveBtn @click="applyColumnSettings(columnsSettings)" />
        <CancelBtn @click="closeMenu" />
      </v-card-actions>
    </v-card>
  </v-menu>
</template>
<script>
import arrayMove from "array-move";
import * as dataListApi from "../../backend/dataListApi.js";
import ToolbarIconButton from "../ToolbarIconButton.vue";

export default {
  components: {
    ToolbarIconButton,
  },
  props: [
    "columns",
    "resource",
    "groupTitle",
    "flatSettingsButton",
    "colorSettingsButton",
    "iconColorSettingsButton",
    "isTopPositionSettingsButton",
  ],
  data() {
    return {
      menu: false,
      menuSave: false,
      settingTitle: "",
      columnsSettings: [],
    };
  },
  computed: {
    availableColumns() {
      if (!this.columnsSettings.length) {
        return;
      }
      return this.columnsSettings.filter(
        c => c.visible === false && c.type !== "icon",
      );
    },
    selectedColumns() {
      if (!this.columnsSettings.length) {
        return;
      }
      this.columnsSettings.forEach(item => {
        if (item.type === "group") {
          item.title = this.groupTitle;
        }
      });
      return this.columnsSettings.filter(
        c => c.visible === true && c.type !== "icon",
      );
    },
    savedSettings: {
      get() {
        return this.$store.getters[`${this.resource}/savedSettings`];
      },
      set(savedSettings) {
        this.$store.commit(`${this.resource}/setSavedSettings`, savedSettings);
      },
    },
    selected: {
      get() {
        return this.$store.getters[`${this.resource}/selectedSetting`];
      },
      set(value) {
        this.$store.commit(`${this.resource}/setSelectedSetting`, value);
      },
    },
    storeColumns: {
      get() {
        return this.$store.getters[`${this.resource}/columns`];
      },
      set(columns) {
        this.$store.commit(`${this.resource}/setColumns`, columns);
      },
    },
  },
  watch: {
    columns: {
      handler(value) {
        const parsed = JSON.stringify(value);
        localStorage.setItem("settings", parsed);
        this.updateColumnSettings(value);
      },
      deep: true,
    },
    menuSave(value) {
      if (value && this.selected) {
        this.settingTitle = this.selected.title;
      } else {
        this.settingTitle = "";
      }
    },
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      const result = await dataListApi.getColumnSettings(this.resource);
      this.savedSettings = result.map(s => {
        return {
          id: s.id,
          title: s.title,
          settings: s.settings,
        };
      });
      if (this.storeColumns.length) {
        this.applyColumnSettings(this.storeColumns);
      } else if (result.length > 0) {
        this.selected = {
          id: result[0].id,
          title: result[0].title,
          settings: result[0].settings,
        };
        this.applyColumnSettings(JSON.parse(result[0].settings));
      } else {
        this.savedSettings = [];
        this.savedSetting = null;
        this.updateColumnSettings(this.columns);
      }
    },
    moveColumn(item, subItem) {
      if (!item || item.type === "group") {
        return;
      }

      this.columnsSettings.forEach(c => {
        if (c.name === item.name) {
          c.visible = !item.visible;
          c.order = item.order;
          c.children = item.children;
        }
        if (subItem) {
          this.columnsSettings
            .find(c => c.name === item.name)
            .children.forEach(i => {
              if (i.name === subItem.name) {
                c.visible = !subItem.visible;
                c.order = subItem.order;
              }
            });
        }
      });
    },
    moveColumnUp(item, subItem) {
      if (subItem) {
        let items = this.columnsSettings.find(c => c.name === item.name)
          .children;
        const index = items.indexOf(items.find(i => i.name === subItem.name));
        items = arrayMove(items, index, index - 1 > -1 ? index - 1 : 0);

        items.forEach((item, index) => (item.order = index));

        this.columnsSettings.find(c => c.name === item.name).children = items;
      } else {
        const index = this.columnsSettings.indexOf(
          this.columnsSettings.find(c => c.name === item.name),
        );
        this.columnsSettings = arrayMove(
          this.columnsSettings,
          index,
          index - 1 > -1 ? index - 1 : 0,
        );
        this.columnsSettings.forEach((c, index) => (c.order = index));
      }
    },
    moveColumnDown(item, subItem) {
      if (subItem) {
        let items = this.columnsSettings.find(c => c.name === item.name)
          .children;
        const index = items.indexOf(items.find(i => i.name === subItem.name));
        items = arrayMove(items, index, index + 1);

        items.forEach((item, index) => (item.order = index));

        this.columnsSettings.find(c => c.name === item.name).children = items;
      } else {
        const index = this.columnsSettings.indexOf(
          this.columnsSettings.find(c => c.name === item.name),
        );
        this.columnsSettings = arrayMove(
          this.columnsSettings,
          index,
          index + 1,
        );
        this.columnsSettings.forEach((c, index) => (c.order = index));
      }
    },
    async applyColumnSettings(settings) {
      if (!settings.length) {
        return;
      }
      await settings.forEach(s => {
        const column = this.columns.find(c => c.name === s.name);
        if (column) {
          this.$set(column, "visible", s.visible);
          this.$set(column, "order", s.order);
        }
        if (column && column.children) {
          s.children.forEach(ch => {
            const subColumn = column.children.find(i => i.name === ch.name);
            if (subColumn) {
              this.$set(subColumn, "visible", ch.visible);
              this.$set(subColumn, "order", ch.order);
            }
          });
        }
      });
      this.menu = false;
      this.$store.commit(`${this.resource}/setColumns`, this.columnsSettings);
    },
    updateColumnSettings(resource) {
      this.columnsSettings = resource.map(c => {
        return {
          title: c.title,
          name: c.name,
          type: c.type ? c.type : "",
          visible: Object.prototype.hasOwnProperty.call(c, "visible")
            ? c.visible
            : true,
          order: Object.prototype.hasOwnProperty.call(c, "order") ? c.order : 0,
          children: c.children
            ? c.children
              .map(i => {
                return {
                  title: i.title,
                  name: i.name,
                  type: i.type ? i.type : "",
                  visible: Object.prototype.hasOwnProperty.call(i, "visible")
                    ? i.visible
                    : true,
                  order: Object.prototype.hasOwnProperty.call(i, "order")
                    ? i.order
                    : 0,
                };
              })
              .sort((a, b) => {
                return a.order - b.order;
              })
            : null,
        };
      });
      this.columnsSettings.sort((a, b) => {
        return a.order - b.order;
      });
    },
    closeMenu() {
      this.menu = false;
      this.updateColumnSettings(this.columns);
    },
    async processSetting(setting) {
      await this.getSetting(setting);
      this.changeDateSettings(setting);
    },
    async getSetting(setting) {
      if (setting) {
        const res = await dataListApi.getSettings(setting.id);
        this.applyColumnSettings(JSON.parse(res.data.Settings));
      }
    },
    changeDateSettings(setting) {
      if (setting) {
        dataListApi.changeDateSettings(setting.id);
      }
    },
    async saveSetting() {
      const setting = {
        resource: this.resource,
        title: this.settingTitle,
        settings: JSON.stringify(this.columnsSettings),
      };
      if (this.selected) {
        this.savedSettings = await dataListApi.updateColumnSettings(
          this.selected.id,
          setting,
        );
        this.selected = this.savedSettings.find(s => s.id === this.selected.id);
        this.menuSave = false;
      } else {
        this.savedSettings = await dataListApi.createColumnSettings(setting);
        this.selected = this.savedSettings.find(s => s.title === setting.title);
        this.settingTitle = "";
        this.menuSave = false;
      }
      this.menu = false;
      this.applyColumnSettings(this.columnsSettings);
    },
    async deleteSetting(setting) {
      if (confirm("Удалить настройку?")) {
        await dataListApi.deleteSetting(setting.id);
        this.selected = null;
        this.clearSelected();
        this.getData();
        this.showInfo("Настройка удалена");
      }
    },
    clearSelected() {
      this.columnsSettings.forEach(c => {
        c.visible = true;
        c.order = 0;
      });
    },
  },
};
</script>
